import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

export interface EntityCardSkeletonProps {
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Generic skeleton loader for any EntityCard type
 * Follows the standard pattern used across all entity cards
 */
export function EntityCardSkeleton({
  className,
  style,
}: EntityCardSkeletonProps) {
  return (
    <Card
      className={cn("w-full transition-colors h-[90px]", className)}
      style={style}
    >
      <CardContent className="p-3">
        <div className="flex items-start gap-3">
          {/* Avatar skeleton */}
          <Skeleton className="h-10 w-10 rounded-full flex-shrink-0" />

          {/* Content skeleton */}
          <div className="flex-1 min-w-0">
            {/* Title/header line */}
            <Skeleton className="h-4 w-1/3 mb-1.5" />

            {/* Description/content lines */}
            <Skeleton className="h-4 w-3/4 mb-1.5" />
            <Skeleton className="h-3 w-1/2" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default EntityCardSkeleton;
